// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"5922fe70","266":"761cf573","400":"d3474813","653":"8ad772b3","673":"cccd8131"}[chunkId] + ".chunk.js";
};